const closeButtonLabel = "Schließen";
const deDE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  deDE as default
};
